import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { DateProvider } from '../../../providers';
import {
  Container,
  PointsContainer,
  PointsItem,
  Space,
  TeamName,
  TeamNameAway,
  Timer,
} from './styles';

function SoccerSerieA({ data }) {
  const { awayTeam, homeTeam, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return '00:00';
    const [minutes, seconds] = DateProvider.getSoccerTime(time);
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        <TeamName>{homeTeam.name}</TeamName>
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V54L23.8605 0H0Z"
            fill="#172E8C"
          />
          <path
            d="M23.8605 0L0 54H16.3256L38.9302 0H23.8605Z"
            fill={homeTeam?.colors?.[0]?.value || '#1A1A1A'}
          />
          <path
            d="M38.9302 0L16.3256 54H31.3953L54 0H38.9302Z"
            fill={homeTeam?.colors?.[1]?.value || '#0D8FD6'}
          />
          <path d="M54 0L31.3953 54H54V0Z" fill="#F1F1F1" />
        </svg>
        <PointsContainer>
          <PointsItem>{homeTeam.points}</PointsItem>
          <Space>-</Space>
          <PointsItem>{awayTeam.points}</PointsItem>
        </PointsContainer>
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V54L23.8605 0H0Z"
            fill="#F1F1F1"
          />
          <path
            d="M23.8605 0L0 54H16.3256L38.9302 0H23.8605Z"
            fill={awayTeam?.colors?.[0]?.value || '#0F8738'}
          />
          <path
            d="M38.9302 0L16.3256 54H31.3953L54 0H38.9302Z"
            fill={awayTeam?.colors?.[1]?.value || '#1A1A1A'}
          />
          <path d="M54 0L31.3953 54H54V0Z" fill="#2754B7" />
        </svg>
        <TeamNameAway>{awayTeam.name}</TeamNameAway>
        <Timer>{getTime()}</Timer>
        <svg
          width="24"
          height="54"
          viewBox="0 0 24 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V54L23.8605 0H0Z"
            fill="#0C1C6B"
          />
        </svg>
      </Container>
    </>
  );
}

SoccerSerieA.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
  styles: PropTypes.shape({}),
};

SoccerSerieA.defaultProps = {
  data: {
    awayTeam: {
      colors: [
        { id: 1, value: '#0F8738' },
        { id: 2, value: '#1A1A1A' },
      ],
      name: 'SAS',
      points: 0,
    },
    homeTeam: {
      colors: [
        { id: 1, value: '#1A1A1A' },
        { id: 2, value: '#0D8FD6' },
      ],
      name: 'ATA',
      points: 0,
    },
    status: 'paused',
    time: [],
  },
  styles: {},
};

export default SoccerSerieA;
